import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.css'],
})
export class SingleComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  charCount: number = 0;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string;
  }>();

  handleInput(event: Event): void {
    const inputEl = event.target as HTMLTextAreaElement;
    const inputValue = inputEl.value;

    if (inputValue.length > 200) {
      inputEl.value = inputValue.substring(0, 200);
      this.charCount = 200;
    } else {
      this.charCount = inputValue.length;
    }

    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: inputValue,
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
